"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidateSchema = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var yup = __importStar(require("yup"));
var useValidateSchema = function (_a) {
    var fields = _a.fields, currencySymbol = _a.currencySymbol, min = _a.min, max = _a.max, withdrawalBalance = _a.withdrawalBalance, minFromSettings = _a.minFromSettings, maxFromSettings = _a.maxFromSettings;
    var t = (0, next_intl_1.useTranslations)('errors');
    return (0, react_1.useMemo)(function () {
        var yupFields = {};
        fields.forEach(function (field) {
            if (field === 'phone')
                return (yupFields[field] = yup
                    .string()
                    .required("".concat(t("customer.".concat(field, ".isRequired"))))
                    .min(8, t('phoneIsInvalid')));
            if (field === 'cardYear' || field === 'cardMonth') {
                return (yupFields.expirationDate = yup
                    .string()
                    .required("".concat(t("customer.expirationDate.isRequired")))
                    .min(5, t("customer.expirationDate.isInvalid")));
            }
            if (field === 'cardNumber' || field === 'card_number') {
                return (yupFields[field] = yup
                    .string()
                    .required("".concat(t("customer.".concat(field, ".isRequired"))))
                    .test('card-length', t("customer.".concat(field, ".invalidLength")), function (value) {
                    if (!value)
                        return true;
                    var digitsOnly = value.replace(/\D/g, '');
                    return digitsOnly.length === 16;
                }));
            }
            if (field === 'bankAccountType' ||
                field === 'bankCode' ||
                field === 'documentType' ||
                field === 'bankCountry') {
                return (yupFields[field] = yup.object().shape({
                    value: yup.string().required("".concat(t("customer.".concat(field, ".isRequired")))),
                    label: yup.string().required("".concat(t("customer.".concat(field, ".isRequired")))),
                }));
            }
            if (field !== 'amount' &&
                field !== 'accountType' &&
                field !== 'accountOwner' &&
                field !== 'coin' &&
                field !== 'networkType' &&
                field !== 'email' &&
                field !== 'country' &&
                field !== 'currency' &&
                field !== 'fullName') {
                return (yupFields[field] = yup
                    .string()
                    .required("".concat(t("customer.".concat(field, ".isRequired")))));
            }
        }, []);
        return yup.object(__assign({ amount: Number(withdrawalBalance) >= Number(minFromSettings)
                ? yup
                    .number()
                    .positive()
                    .min(Number(minFromSettings), "".concat(t("minAmount"), " ").concat(currencySymbol).concat(Number(minFromSettings)))
                    .max(Number(Number(max) < Number(maxFromSettings)
                    ? Number(max)
                    : Number(maxFromSettings)), "".concat(t("maxAmount"), " ").concat(currencySymbol).concat(Number(max) < Number(maxFromSettings)
                    ? Number(max)
                    : Number(maxFromSettings)))
                    .required(t('amountIsRequired'))
                : yup
                    .number()
                    .positive()
                    .min(Number(minFromSettings), "".concat(t('balanceBelowWithdrawalMin'), " ").concat(currencySymbol).concat(Number(minFromSettings)))
                    .max(Number(max), "".concat(t('balanceBelowWithdrawalMin'), " ").concat(currencySymbol).concat(Number(minFromSettings)))
                    .required(t('amountIsRequired')) }, yupFields));
    }, [
        fields,
        t,
        currencySymbol,
        withdrawalBalance,
        max,
        minFromSettings,
        maxFromSettings,
    ]);
};
exports.useValidateSchema = useValidateSchema;
